var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectBoxMinor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 2.17599,
    width: 53,
    height: 53,
    rx: 6.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 2.17599,
    width: 53,
    height: 53,
    rx: 6.5,
    stroke: "#0089EC",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.05 25.2093L41.4833 21.6427L31.6833 13.7427L28.3167 17.3427L24.8833 13.676L15.0167 21.6427L18.45 25.2093L15.0167 28.776L18.75 31.7927V36.0593L28.2833 43.676L37.8 36.0593V31.7427L41.4833 28.7927L38.05 25.2093ZM28.25 30.7593L21.3167 25.2093L28.25 19.676L35.25 25.2093L28.25 30.7593ZM36.5833 26.4427L38.6667 28.6093L31.9167 34.1427L29.75 31.9593L36.5833 26.4427ZM31.9167 16.2927L38.7833 21.8093L36.6333 24.0093L29.75 18.476L31.9167 16.2927ZM24.7333 16.2093L26.9167 18.4093L19.8667 24.0093L17.7833 21.8093L24.7333 16.2093ZM19.8667 26.4427L26.9167 32.0093L24.7167 34.2093L17.7833 28.6093L19.8667 26.4427ZM20.6333 33.3093L24.8833 36.7427L27.3833 34.1427V40.5593L20.7167 35.1593L20.6333 33.3093ZM35.9333 35.1593L29.2667 40.4927V34.1427L31.7 36.676L35.95 33.3427V35.2427L35.9333 35.1593Z",
    fill: "#0089EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectBoxMinor);
export default __webpack_public_path__ + "static/media/object-box-minor.8af49f561e2c32e36d575087b0e66765.svg";
export { ForwardRef as ReactComponent };